import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { PaymentInformation } from '../payment/PaymentInformation'
import { useOfferState } from '../payment/useOfferState'
import type { RecurringSubscriptionInterval } from '@jotta/grpc-connect-openapi/payment'
import { PaymentLayout } from '../payment/PaymentLayout'
import { usePaymentInfo } from '../payment/usePaymentInformation'
import { useSearchParams } from 'react-router-dom'
import { useLayoutEffect } from 'react'
import { BrandIcon } from '@jotta/ui/BrandIcon'
import SvgBoldCaretLeft from '@jotta/ui/SvgBoldCaretLeft'
import Spinner from '@jotta/ui/Spinner'
import { successUrl } from '../auth/PaidSignup'

export const ConfirmUpgrade: React.FC<{
  productCode: string
  subscriptionInterval: RecurringSubscriptionInterval
}> = ({ productCode, subscriptionInterval }) => {
  const [search, setSearch] = useSearchParams()
  const getPaymentInfoResponse = usePaymentInfo().data
  const extraStorageTB = Math.round(
    Number(
      (getPaymentInfoResponse?.extraStorageBytes || 0n) / 1_000_000_000_000n,
    ),
  )

  const offerState = useOfferState(productCode, subscriptionInterval, {
    initialExtraStorageTB: extraStorageTB,
    initialExtraSeats: getPaymentInfoResponse?.extraSeats,
  })
  const { offer, interval } = offerState

  useLayoutEffect(() => {
    if (search.has('extra')) {
      setSearch(new URLSearchParams(), { replace: true })
    }
  }, [search, setSearch])

  if (!offer) {
    return (
      <div className="my-auto flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <PaymentLayout
      backPath="/web/upgrade"
      backElement={
        <div className="label-sm flex h-12 min-w-12 items-center gap-2">
          <BrandIcon icon={SvgBoldCaretLeft} width={16} height={16} />
          <p>
            <Trans>Back</Trans>
          </p>
        </div>
      }
      offer={offer}
      interval={interval}
      title={t`Enter payment details`}
    >
      {summary => (
        <PaymentInformation
          offerState={offerState}
          successUrl={successUrl(offer, interval, false)}
          summary={summary}
        />
      )}
    </PaymentLayout>
  )
}
